import React from 'react'
import cx from 'classnames'
import { l, sanitizeURL } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { openConnectChannelModal } from 'common/core/actions/uiActions'
import { ChannelDisconnectionEvent } from 'common/core/constants/ChannelDisconnectionEvents'
import { ChannelType, ConnectChannelModalSource } from 'common/core/constants/ChannelType'
import { useGetPermissionHref } from 'common/core/hooks/permissions/useGetPermissionHref'
import { getFacebookBannerAction } from 'common/core/lib/refreshPermissions'
import { getRefreshPermissionsData } from 'common/core/selectors/refreshPermissionsSelectors'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const RefreshAdminPermissionsNotification = () => {
  const dispatch = useAppDispatch()
  const refreshPermissionsData = useAppSelector(getRefreshPermissionsData)
  const action = getFacebookBannerAction(refreshPermissionsData)
  const { getPermissionHref } = useGetPermissionHref()

  useDidMountEffect(() => {
    if (!action) return

    analyticsService.sendEvent(ChannelDisconnectionEvent.BANNER_SHOWN, {
      channel: ChannelType.FB,
    })
  })

  const getAdminPermissionsLink = () => {
    if (action?.type === 'refresh-permissions') {
      return sanitizeURL(getPermissionHref(action.permissionType, window.location.href))
    }
    return undefined
  }

  const handleRefresh = () => {
    analyticsService.sendEvent('REFRESH_ADMIN_PERMISSIONS_BANNER.CLICKED')
    if (action?.type === 'connect-channel') {
      dispatch(
        openConnectChannelModal(
          [ChannelType.FB, ChannelType.EMAIL, ChannelType.SMS],
          ConnectChannelModalSource.REFRESH_ADMIN_PERMISSIONS,
        ),
      )
    }
  }

  if (!action) return null

  return (
    <>
      <span>
        {l.translate(
          "Some issues with account's permissions were found. Facebook page Admin has to Refresh Permissions.",
        )}
      </span>
      <a href={getAdminPermissionsLink()} onClick={handleRefresh} className={cx(cm.more, 'm-l-xs')}>
        {l.translate('Refresh Permissions')}
      </a>
    </>
  )
}
